<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Summary for: {{ alert.name }}</h2>
        <hr>
        <router-link :to="{ name: 'AlertIndex' }" class="btn btn-light">
          <i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i>Back
        </router-link>
        <a class="btn btn-light" @click="executeAlert(alert_id)">
          <i class="fa fa-play fa-fw" aria-hidden="true"></i> Execute
        </a>

      </div>
    </div>
    <br>
    <div class="row">
        <div class="col-12">
            <General :alert_id="alert_id"></General>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-12">
            <StepsTable :alert_id="alert_id"></StepsTable>
        </div>
    </div>
    <br>
    <div class="row" v-if="feature_visual_alert_enabled">
        <div class="col-12">
            <VisualCards :alert_id="alert_id"></VisualCards>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import General from '../../components/Alert/General'
import StepsTable from '../../components/Alert/StepsTable'
import VisualCards from '../../components/Alert/VisualCards'

export default {
  props: { alert_id: { type: [Number, String] } },
  components: { General, StepsTable, VisualCards },
  computed: {
    ...mapGetters({
      alert: 'singleAlert',
      feature_visual_alert_enabled: 'featureVisualAlertEnabled'
    })
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getAlert', this.alert_id)
  },
  methods: {
    ...mapActions(['deleteAlertStep', 'executeAlert']),
    reorderAlertStep (alertStepId, direction) {
      let params = {}

      params.alert_step_id = alertStepId
      params.alert_id = this.alert_id
      params.direction = direction

      this.$store.dispatch('reorderAlertStep', params)
    },
    changeOrderType (orderTypeId) {
      this.alert_step_order_type_id = orderTypeId
    }
  }
}
</script>

<style scoped>
</style>
